<template>
  <PcDialog
    v-if="self.isShow"
    :self="self"
    :title="dialogTitle"
    width="1300px"
    submitBtnText="确定"
    @submit="submitSelect"
    @close="close"
  >
    <div class="select-clinic-main">
      <div class="left">
        <PcTopSearch @searchclick="searchClick" @clear="clearClick">
          <template #nomal>
            <div class="searchitem pcmr16 pcw200">
              <PcClinicRegionSelect v-model="searchForm.structId" />
            </div>
            <div class="searchitem pcmr16 pcw250">
              <PcInput
                v-model="searchForm.search"
                leftTitle="门店名称、简称"
                placeholder="请输入"
                clearable
              />
            </div>
          </template>
        </PcTopSearch>

        <el-table
          ref="leftTable"
          v-loading="leftTableLoading"
          :data="leftTableData"
          row-key="id"
          height="450px"
          style="width: 100%"
          :header-cell-style="tableStyle.tableHeaderCell"
          :cell-style="tableStyle.tableCellstyle"
          border
          @selection-change="handleLeftSelectionChange"
        >
          <el-table-column
            type="selection"
            width="40"
            align="center"
            :selectable="canSelectLeftRow"
          />
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="60"
          />
          <el-table-column
            prop="structName"
            label="门店区域"
            show-overflow-tooltip
          />
          <el-table-column
            prop="abbreviation"
            label="门店简称"
            show-overflow-tooltip
          />
          <el-table-column
            prop="clinicName"
            label="门店名称"
            show-overflow-tooltip
          />
          <el-table-column label="操作" width="60">
            <template #default="{ row }">
              <el-button
                :disabled="isRowAddDisabled(row)"
                type="primary"
                link
                @click="tableTableAdd(row)"
              >
                {{ addBtnText }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="row mt10">
          <div class="flex-1">
            <el-button plain @click="handleBatchAdd">
              {{ batchAddBtnText }}
            </el-button>
          </div>
          <el-pagination
            background
            :current-page="pages.current"
            :page-size="pages.size"
            :page-sizes="[10, 20, 50]"
            layout="total, sizes, prev, pager, next"
            :total="pages.total"
            :pager-count="5"
            @size-change="sizeChange"
            @current-change="currentChange"
          />
        </div>
      </div>

      <div class="right">
        <div class="p-title-line">
          <span>{{ selectedSummaryPrefix }}</span>
          <span class="font-main ml4 mr4">{{ selectedTableData.length }}</span>
          <span>{{ selectedSummarySuffix }}</span>
        </div>
        <div class="mt8">
          <el-table
            :data="selectedTableData"
            height="515px"
            style="width: 100%"
            :header-cell-style="tableStyle.tableHeaderCell"
            :cell-style="tableStyle.tableCellstyle"
            border
          >
            <el-table-column
              type="index"
              label="序号"
              align="center"
              width="60"
            />
            <el-table-column
              prop="structName"
              label="门店区域"
              show-overflow-tooltip
            />
            <el-table-column
              prop="abbreviation"
              label="门店简称"
              show-overflow-tooltip
            />
            <el-table-column
              prop="clinicName"
              label="门店名称"
              show-overflow-tooltip
            />
            <el-table-column label="操作" width="60">
              <template #default="{ row }">
                <el-button type="danger" link @click="tableTableDelete(row)">
                  {{ removeBtnText }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </PcDialog>
</template>

<script>
import {
  getClinicDetailById,
  getClinicPageByWecomId,
  getTopArea,
} from "@/api/base.js";
import tableStyle from "@/assets/pc/js/config/publicTableStyle.js";
import { getClinicListByIds } from "@/api/options.js";
import { userStore } from "@/store/user.js";
import PcClinicRegionSelect from "@/components/pc/public/PcClinicRegionSelect.vue";

export default {
  name: "SelectClinicDialog",
  components: { PcClinicRegionSelect },
  props: {
    self: {
      type: Object,
      default: () => ({ isShow: false }),
    },
    //已选中的门店列表
    selectedList: {
      type: Array,
      default: () => [],
    },
    //是否需要默认当前区域
    needDefaultStructId: {
      type: Boolean,
      default: true,
    },
    dialogTitle: {
      type: String,
      default: "选择门店",
    },
    addBtnText: {
      type: String,
      default: "添加",
    },
    batchAddBtnText: {
      type: String,
      default: "批量添加",
    },
    removeBtnText: {
      type: String,
      default: "删除",
    },
    selectedSummaryPrefix: {
      type: String,
      default: "已选",
    },
    selectedSummarySuffix: {
      type: String,
      default: "家门店",
    },
    duplicateWarning: {
      type: String,
      default: "门店已在列表中，请勿重复添加",
    },
    batchAddEmptyWarning: {
      type: String,
      default: "请选择要批量添加的门店",
    },
    /** 最大可选门店数，0 表示不限制 */
    maxSelectCount: {
      type: Number,
      default: 0,
    },
    //禁用的门店id列表
    disabledIdList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["save"],
  data() {
    return {
      defaultStructId: "",
      searchForm: {
        search: "",
        structId: "",
      },
      leftTableData: [],
      leftTableLoading: false,
      leftTableSelection: [],
      selectedTableData: [],
      pages: {
        current: 1,
        size: 20,
        total: 0,
      },
      tableStyle,
    };
  },
  mounted() {
    const user = userStore();
    const clinicId = user.userInfo.detail.clinic_id;
    //将已经保存的数组放入右边
    this.getRightTableData(this.selectedList);
    //先获取当前门店关联的企微id
    this.getWecomId(clinicId)
      .then(() => {
        //是否需要默认当前区域
        if (this.needDefaultStructId) {
          return getTopArea({ id: clinicId }).then((res) => {
            const data = res.data.data || {};
            const firstStructId = String(data.firstStructId || "");
            //将默认选中的区域id设置为当前门店所在区域
            this.defaultStructId = firstStructId;
            this.searchForm.structId = firstStructId;
          });
        }
      })
      .then(() => {
        this.fetchClinicPage();
      });
  },
  methods: {
    getWecomId(clinicId) {
      return getClinicDetailById(clinicId).then((res) => {
        const { data = {} } = res.data;
        this.wecomId = data.wecomId || "";
      });
    },
    fetchClinicPage() {
      const params = {
        openWecom: this.wecomId,
        isWorkPlace: 1,
        structIds: this.searchForm.structId || "",
        search: this.searchForm.search || "",
        status: 0,
        current: this.pages.current,
        size: this.pages.size,
      };

      this.leftTableLoading = true;

      getClinicPageByWecomId(params)
        .then((res) => {
          const { records, total } = res.data.data || {};
          this.leftTableData = records;
          this.pages.total = total;

          this.$nextTick(() => {
            this.syncLeftTableSelectionWithSelected();
          });
        })
        .finally(() => {
          this.leftTableLoading = false;
        });
    },
    sizeChange(size) {
      this.pages.size = size;
      this.pages.current = 1;
      this.fetchClinicPage();
    },
    currentChange(current) {
      this.pages.current = current;
      this.fetchClinicPage();
    },
    handleLeftSelectionChange(selection) {
      this.leftTableSelection = selection;
    },
    isRowAddDisabled(row) {
      if (this.selectedTableData.some((item) => item.id === row.id))
        return true;
      if (
        this.maxSelectCount > 0 &&
        this.selectedTableData.length >= this.maxSelectCount
      )
        return true;
      return false;
    },
    canSelectLeftRow(row) {
      if (this.selectedTableData.some((item) => item.id === row.id))
        return false;
      if (this.disabledIdList.some((id) => id === row.id)) return false;
      if (
        this.maxSelectCount > 0 &&
        this.selectedTableData.length >= this.maxSelectCount
      )
        return false;
      return true;
    },
    syncLeftTableSelectionWithSelected() {
      const table = this.$refs.leftTable;
      if (!table || !this.leftTableData.length) return;
      this.leftTableData.forEach((row) => {
        const inRight = this.selectedTableData.some(
          (item) => item.id === row.id,
        );
        if (inRight) {
          table.toggleRowSelection(row, true);
        }
      });
    },
    handleBatchAdd() {
      const selection = this.leftTableSelection || [];
      let toAdd = selection.filter((row) => this.canSelectLeftRow(row));
      if (!toAdd.length) {
        this.$message.warning(this.batchAddEmptyWarning);
        return;
      }
      if (this.maxSelectCount > 0) {
        const slots = this.maxSelectCount - this.selectedTableData.length;
        if (slots <= 0) {
          this.$message.warning(`最多只能选择${this.maxSelectCount}家门店`);
          return;
        }
        if (toAdd.length > slots) {
          this.$message.warning(`最多还能选择${slots}家门店`);
          toAdd = toAdd.slice(0, slots);
        }
      }
      toAdd.forEach((row) => this.selectedTableData.push(row));
      this.$nextTick(() => {
        const table = this.$refs.leftTable;
        if (table) {
          toAdd.forEach((row) => {
            const target = this.leftTableData.find((r) => r.id === row.id);
            if (target) table.toggleRowSelection(target, true);
          });
        }
        this.leftTableSelection = [];
      });
    },
    searchClick() {
      this.pages.current = 1;
      this.fetchClinicPage();
    },
    clearClick() {
      this.searchForm.search = "";
      this.searchForm.structId = this.defaultStructId;
      this.pages.current = 1;
      this.fetchClinicPage();
    },
    tableTableAdd(row) {
      if (
        this.maxSelectCount > 0 &&
        this.selectedTableData.length >= this.maxSelectCount
      ) {
        this.$message.warning(`最多只能选择${this.maxSelectCount}家门店`);
        return;
      }
      if (this.selectedTableData.some((item) => item.id === row.id)) {
        this.$message.warning(this.duplicateWarning);
        return;
      }
      this.selectedTableData.push(row);
      this.$nextTick(() => {
        const table = this.$refs.leftTable;
        const target = this.leftTableData.find((r) => r.id === row.id);
        if (table && target) table.toggleRowSelection(target, true);
      });
    },
    tableTableDelete(row) {
      const index = this.selectedTableData.findIndex(
        (item) => item.id === row.id,
      );
      if (index !== -1) {
        this.selectedTableData.splice(index, 1);
        this.$nextTick(() => {
          const table = this.$refs.leftTable;
          const target = this.leftTableData.find((r) => r.id === row.id);
          if (table && target) table.toggleRowSelection(target, false);
        });
      }
    },
    submitSelect() {
      this.$emit("save", this.selectedTableData);
      this.close();
    },
    close() {
      this.self.isShow = false;
    },
    //加载右侧已选门店列表数据
    getRightTableData(list = []) {
      if (!list.length) {
        this.selectedTableData = [];
        return;
      }
      // 若传入数据已携带 abbreviation、clinicName 字段，直接复用，避免重复请求
      const hasDisplayFields = list.every(
        (item) => "abbreviation" in item && "clinicName" in item,
      );
      if (hasDisplayFields) {
        this.selectedTableData = list.map(
          ({ abbreviation, clinicName, id, structName }) => ({
            abbreviation,
            clinicName,
            id,
            structName,
          }),
        );
        return;
      }
      const ids = list.map(({ id }) => id);
      getClinicListByIds(ids).then((res) => {
        const { data } = res.data || [];
        this.selectedTableData = data.map(
          ({ abbreviation, clinicName, id, structName }) => ({
            abbreviation,
            clinicName,
            id,
            structName,
          }),
        );
      });
    },
  },
};
</script>

<style scoped lang="scss">
.select-clinic-main {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  text-align: left;

  .left,
  .right {
    flex: 1;
    min-width: 0;
  }

  :deep(.el-checkbox) {
    margin: 0 !important;
  }
}

.search-item {
  display: inline-flex;
  align-items: center;
  margin-right: 12px;
}

.p-title-line {
  font-size: 14px;
  color: #606266;

  .font-main {
    color: #28b8c3;
    font-weight: 600;
  }
}
</style>
